import React from 'react';
import { CSummaryCard, CSummaryCardProps } from './CSummaryCard';
import { Grid } from '@mui/material';

export type CSummaryCardsInlineProps = {
	list: CSummaryCardProps[];
};
export const CSummaryCardsInline = (props: CSummaryCardsInlineProps) => {
	const { list } = props;
	return (
		<Grid container justifyContent="space-between" spacing={2}>
			{list?.map((x) => (
				<Grid item sm={4} key={x.title}>
					<CSummaryCard {...x} />
				</Grid>
			))}
		</Grid>
	);
};
